import { Button, Card, Form, Input, Message, Typography } from '@arco-design/web-react';
import { IconLock, IconUser } from '@arco-design/web-react/icon';
import { useNavigate } from 'react-router-dom';
import { useAdminAuthStore } from '@/store/authStore';
import type { AdminLoginRequest } from '@/types/admin';

export default function LoginView() {
  const navigate = useNavigate();
  const { login, loading } = useAdminAuthStore();
  const [form] = Form.useForm<AdminLoginRequest>();

  const onSubmit = async () => {
    try {
      const values = await form.validate();
      await login(values);
      Message.success('登录成功');
      navigate('/dashboard');
    } catch (e) {
      if (e instanceof Error && !('isBusinessError' in e)) {
        // 校验失败的错误由 Form 自身提示，此处忽略
      }
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0f1f48 0%, #2e5bff 100%)',
      }}
    >
      <Card style={{ width: 380, borderRadius: 16, boxShadow: '0 12px 32px rgba(0,0,0,0.18)' }}>
        <Typography.Title heading={4} style={{ marginTop: 0 }}>
          UP·CARD 管理后台
        </Typography.Title>
        <Typography.Text type="secondary">
          请使用部署侧配置的管理员账号登录
        </Typography.Text>
        <Form form={form} layout="vertical" style={{ marginTop: 20 }} onSubmit={onSubmit}>
          <Form.Item field="username" rules={[{ required: true, message: '请输入管理员账号' }]}>
            <Input prefix={<IconUser />} placeholder="管理员账号" allowClear />
          </Form.Item>
          <Form.Item field="password" rules={[{ required: true, message: '请输入登录密码' }]}>
            <Input.Password prefix={<IconLock />} placeholder="登录密码" />
          </Form.Item>
          <Button type="primary" long loading={loading} onClick={onSubmit}>
            登录
          </Button>
        </Form>
      </Card>
    </div>
  );
}
